import { Fade, Slide } from '@mui/material';
import type { Theme } from '@mui/material/styles';

/**
 * The transition props for notistack's `SnackbarProvider`, from the theme.
 * notistack runs its own transitions rather than the theme's, so the toast
 * animation and an animations-off theme (zero durations) are passed on here.
 * Sliding in from the side is notistack's own default, so it adds nothing.
 */
export function toastTransitionProps(theme: Theme) {
  const off = theme.transitions.duration.enteringScreen === 0;
  return {
    ...(off && {
      transitionDuration: {
        enter: 0,
        exit: 0
      }
    }),
    ...(theme.toastAnimation === 'fade' && {
      TransitionComponent: Fade
    }),
    ...(theme.toastAnimation === 'slideBottom' && {
      TransitionComponent: Slide,
      TransitionProps: {
        direction: 'up' as const
      }
    })
  };
}